<template>
  <div>
    <!--自助门禁  扫描-->
    <div v-if="!isError">
      <a-skeleton :loading="entranceLoading">
        <div class="mj_one">
          <p>门禁组别：{{ entranceConfig.groupName }}</p>
          <p>通道名称：{{ entranceConfig.passagewayName }}</p>
          <p>通道编码：{{ entranceConfig.passagewayCode }}</p>
        </div>
        <dl class="mj_two">
          <dt>本机位置：{{ entranceConfig.passagewayName }}</dt>
          <dt>操作用户：{{ entranceConfig.userName }}</dt>
        </dl>
        <div class="mj_three">
          <button class="btn_saoMiao" @click="startScan">开始扫描</button>
        </div>

        <ul class="mj_four">
          <template>
            <li>
              <!-- <img src="@/assets/img/mj1.png" alt="" />
          <img src="@/assets/img/mj2.png" alt="" />
          <img src="@/assets/img/mj3.png" alt="" />
          <img src="@/assets/img/mj4.png" alt="" /> -->
            </li>
            <li v-if="successObj.limitCount > 0">
              <span class="s1">{{ successObj.surplusCount }}</span
              >/<span class="s2">{{ successObj.limitCount }}</span>
            </li>
            <li>
              <!-- <img src="@/assets/img/mj5.png" alt="" />
          <img src="@/assets/img/mj6.png" alt="" />
          <img src="@/assets/img/mj7.png" alt="" />
          <img src="@/assets/img/mj8.png" alt="" /> -->
            </li>
          </template>
        </ul>
        <dl class="mj_five">
          <dt>入场时间：{{ now }}</dt>
          <dt>入场位置：{{ entranceConfig.passagewayCode }}</dt>
        </dl>
      </a-skeleton>
      <div
        class="stats-container"
        :style="{ background: statsLoading ? 'rgba(0, 0, 0, 0.05)' : '' }"
      >
        <a-spin tip="正在加载..." :spinning="statsLoading">
          <ul class="mj_six">
            <li>
              <img src="@/assets/img/mj9.png" alt="" />
              <h2 class="num">{{ stats.todayVisitors }}</h2>
              <p>总人次</p>
            </li>
            <li>
              <img src="@/assets/img/mj10.png" alt="" />
              <h2 class="num">{{ stats.totalPeople }}</h2>
              <p>总人数</p>
            </li>
            <li class="li">
              <img src="@/assets/img/mj11.png" alt="" />
              <h2 class="num">{{ stats.todayVisitors }}</h2>
              <p>今日人次</p>
            </li>
            <li class="li">
              <img src="@/assets/img/mj12.png" alt="" />
              <h2 class="num">{{ stats.todayPeople }}</h2>
              <p>今日人数</p>
            </li>
          </ul>
        </a-spin>
      </div>
      <div class="mj_seven">详细数据可往现场管理系统中进行查询</div>
    </div>
    <div v-if="isError">
      <div class="m_Main">
        <div class="m_one">
          <img src="@/assets/img/ts1.png" class="img" />
          <div class="tit">{{ errorObj.cerCode }}</div>
          <div class="desc">
            对不起<br />
            {{ errorObj.errorMessage }}<br />
            <!-- <span>（8次）</span> -->
          </div>
        </div>
        <div class="m_btn">
          <!-- <button class="btn">欢迎入场</button> -->
          <button class="btn btnRed" @click="isError = false">拒绝入场</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapGetters, mapState, mapMutations } from "vuex";
import message from "ant-design-vue/lib/message";
export default {
  name: "",
  data() {
    return {
      scanText: "",
      isError: false,
      errorCode: 0,
      errorMessage: "",
      statsLoading: false,
      stats: {
        totalVisitors: 0,
        totalPeople: 0,
        todayVisitors: 0,
        todayPeople: 0,
      },
      entranceLoading: false,
      entranceConfig: {
        groupId: "",
        groupName: "",
        passagewayCode: "",
        passagewayName: "",
        userId: "",
        userName: "",
      },
      successObj: {
        limitCount: 0,
        surplusCount: 0,
      },
      // 错误对象显示
      errorObj: {
        cerCode: "",
        errorMessage: "",
        surplusCount: "",
      },
      formData: {
        alias: this.$route.query.alias,
        pointId: this.$route.query.point,
        code: "",
      },
    };
  },
  mounted() {
    if (this.scannedCode) {
      this.submit(this.scannedCode);
    }
    this.getEntranceConfig();
    this.getStatistic();
  },
  computed: {
    now() {
      return dayjs().format("YYYY-MM-DD HH:mm:ss");
    },
    ...mapState("scanStore", ["scannedCode"]),
    ...mapGetters({
      config: "accessControlStore/getConfig",
    }),
  },
  methods: {
    ...mapMutations("scanStore", ["clearScannedCode"]),
    async getEntranceConfig() {
      // message.open({
      //   content: "配置加载中...",
      //   type: "loading",
      //   duration: 1,
      // });
      this.entranceLoading = true;
      const { alias, p, e } = this.$route.query;
      const res = await this.$get(
        `/api/Gate/GetEntranceConfig?alias=${alias}&pointId=${p}&passagewayId=${e}`
      ).finally(() => {
        this.entranceLoading = false;
      });
      if (res.code === 200) {
        this.entranceConfig = res.data;
      }
    },
    async getStatistic() {
      this.statsLoading = true;
      const { alias, e } = this.$route.query;
      const res = await this.$get(
        `/api/Gate/GetStatistic?alias=${alias}&passagewayId=${e}`
      ).finally(() => {
        this.statsLoading = false;
      });
      if (res.code === 200) {
        this.stats = { ...res.data };
      }
    },
    // 扫码结果回调
    onDecode(text) {
      this.formData.code = text;
    },
    startScan() {
      this.clearScannedCode();
      this.$router.push({ path: "/scan" });
    },
    async submit(code) {
      const { e } = this.$route.query;
      const res = await this.$post("/api/Gate/Start", {
        code,
        passagewayId: e,
      });
      if (res.code === 200) {
        if (res.data.limitCount) {
          this.successObj = { ...res.data };
        }
        this.getStatistic();
      } else {
        this.isError = true;
        this.errorObj.cerCode = res.extras.code;
        this.errorObj.errorMessage = res.message;
      }
    },
    bindNext() {
      this.$router.push("/accessControl/information");
    },
  },
};
</script>

<style lang="less" scoped>
.stats-container {
  text-align: center;
  border-radius: 4px;
  margin-bottom: 20px;
  margin: 20px 0;
}
</style>
